module.exports = __webpack_public_path__ + "img/step5.259c0079.png";